<!-- 
 * @description: 邮箱登陆模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-14 17:13:09
!-->
<template>
  <div
    class="mailbox"
    :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mmailbox' : 'mailbox'"
  >
    <div
      class="back"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mback' : 'back'"
      @click="childMailbox"
    ></div>
    <div class="title">{{ $t("message.navigator_email") }}</div>
    <!-- 邮箱登陆 -->
    <div class="inputBox">
      <div class="input-style">
        <input
          type="text"
          :placeholder="$t('message.input_email_address')"
          class="user"
          v-model.trim="email"
          @click="focusEnd('email')"
          id="email"
        />
      </div>
      <div class="input-style">
        <input
          type="text"
          :placeholder="$t('message.enter_code')"
          class="code"
          v-model.trim="code"
          @click="focusEnd('code')"
          id="code"
        />
        <!-- <p class="input-oper">发送</p> -->
        <div v-show="show" @click="sendEmailCode" class="input-oper sendCode">
          {{ $t("message.get_code") }}
        </div>
        <div v-show="!show" class="input-oper sendCode">
          {{ count }}{{ $t("message.get_code_seconds") }}
        </div>
        <!-- <p :class="['input-oper', { active: !canGetCode }]" @click="getCode">
          {{ codeTip }}
        </p> -->
      </div>
    </div>

    <!-- 登陆按钮 -->
    <div
      class="sendBtn"
      :class="email && code ? 'active' : ''"
      @click="login()"
    >
      {{ $t("message.navigator_lang") }}
    </div>
    <!-- 登陆按钮 end -->

    <!-- or 横线 -->
    <div class="Or"></div>

    <!-- 第三方登陆 -->
    <ul class="thirdPart" v-if="system === 'PC'">
      <li class="facebook" @click="webDotChildLogin('click_pcldy_facebook')">
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li>
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
    </ul>
    <ul class="thirdPart" v-if="system === 'MOBILE'">
      <li class="facebook" @click="webDotChildLogin('click_moldy_facebook')">
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li>
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";
import isEmail from "validator/lib/isEmail";
Vue.use(FBSignInButton);
import { RSSign } from "../../utils/sign.js";

export default {
  name: "RastarMailbox",
  props: ["appId", "pId", "mdId", "ukey", "system", "getCodeShow"],
  data() {
    return {
      region: localStorage.getItem("selected_region") || "EURO",
      //邮箱
      email: "",
      // 验证码
      code: "",
      show: true,
      count: "",
      entryTime: 0,
      timer: null,
      // GoogleParams: {
      //   client_id:
      //     "864612029967-lg671faj52nat87vh7d6tscsashcfcbr.apps.googleusercontent.com",
      // },
      fbSignInParams: {
        scope: "email,user_likes",
        return_scopes: true,
      },
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
    };
  },
  computed: {
    GoogleParams: function () {
      let client_id =
        "453313251686-ukls2rftocdl98pjkelcjta9slleocgd.apps.googleusercontent.com";
      return {
        client_id,
        scope: "email",
      };
    },
  },
  methods: {
    sendCodeShow() {
      this.getCodeShow(false);
    },
    childMailbox() {
      this.$emit("mailbox", false);
    },
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    /*
     *@description: 触发埋点上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:16
     */
    webDotChildLogin(nodeVal) {
      this.$Report.webDotFather(this.pId, this.appId, this.ukey, nodeVal);
    },
    /*
     *@description: 接口错误上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    webErrorlogChild(errorMsg, action) {
      this.$Report.webErrorlogFather(
        this.pId,
        this.appId,
        this.ukey,
        errorMsg,
        action,
      );
    },
    /*
     *@description: 发送邮箱验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:07:33
     */
    verifyBindEmailA(token, uinfoData) {
      let data = {
        ts: new Date().getTime(),
        cch_id: this.pId,
        app_id: this.appId,
        token: token,
        sys_language: this.$Storage.localStorageGet("lang"),
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .sendEmailCode(this.apiUrl.user.send_email, data)
        .then((res) => {
          if (res.code == 200) {
            // 显示倒计时
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            this.$toast(errorMsg);
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            // 邮件已发送或者别的状态
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          }
        })
        .catch((err) => {
          this.$Report.webErrorlogFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            err.msg,
            "发送邮箱验证码",
          );
        });
    },
    // 发送邮箱邮箱验证码
    sendEmailCode() {
      let _this = this;
      if (!isEmail(_this.email)) {
        // 合法邮箱
        return _this.$toast(_this.$t("message.incorrect_email"));
      }
      if (_this.email !== "") {
        _this.$generalMethod
          .freezetoken(_this.pId, _this.appId, _this.mdId)
          .then((res) => {
            if (res.code == 200) {
              let uinfoData = {
                email: this.email,
                type: "login",
              };
              _this.verifyBindEmailA(res.data, uinfoData);
            } else {
              _this.$toast(res.msg.replace(/\[.*?\]/g, ""));
              return;
            }
          });
      }
    },
    /*
     *@description: 邮箱登录前置判断
     *@author: 薛微微
     *@date: 2023-06-21 17:08:53
     */
    login() {
      let _this = this;
      if (!(_this.email && _this.code)) return;
      if (this.system === "PC") {
        _this.webDotChildLogin("click_pcldy_password_login");
      } else {
        _this.webDotChildLogin("click_moldy_password_login");
      }

      //Email正则
      // var ePattern =
      //   /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
      // if (ePattern.test(_this.email)) {

      // } else {
      //   _this.$toast("请输入正确的邮箱地址！");
      //   return;
      // }
      let isCache = this.$Storage.localStorageGet("deviceIdUa");
      if (!isCache) {
        // 不存在就强制刷新页面 deviceIdUa isCache不存在
        location.reload();
      } else {
        // deviceIdUa 存在
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              let uinfoData = {
                uname: _this.email,
                vcode: _this.code,
                bind_type: 4,
                type: 2,
              };
              _this.loginSubmit(res.data, "Email", uinfoData);
            }
          });
      }
    },
    /*
     *@description: 请求登录接口
     *@author: 薛微微
     *@date: 2023-06-21 17:10:00
     */
    loginSubmit(token, ltype, uinfoData) {
      let _this = this;
      let data = {
        ts: new Date().getTime(),
        cch_id: _this.pId,
        app_id: _this.appId,
        md_id: _this.mdId,
        sys_language: this.$Storage.localStorageGet("lang"),
        token: token,
        ltype: ltype,
        euser_region: _this.region,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .login(this.apiUrl.user.normal_login, data)
        .then((res) => {
          if (res.code == 200) {
            _this.$emit("loginSuccess", res);
            // _this.emailBindShow = res.data.email_bind_show;
            // this.$Storage.localStorageSet("show", _this.emailBindShow);
            this.$Storage.localStorageSet("apiUname", _this.username);
            this.$Storage.localStorageSet("apiPwd", _this.password);
            // this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
            // this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
            // this.$Storage.localStorageSet(
            //   "access_token",
            //   res.data.access_token
            // );
            // // 登陆成功埋点
            // if (this.system === "PC") {
            //   _this.webDotChildLogin("login_pcldy_password_success");
            // } else {
            //   _this.webDotChildLogin("login_moldy_password_success");
            // }
            // // 登陆成功了跳转页面
            // window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            _this.$toast(errorMsg);
          }
        })
        .catch((err) => {
          this.$toast(err.replace(/\[.*?\]/g, ""));
          this.webErrorlogChild(err.msg, "账号login接口");
        });
    },
    /*
     *@description: FB登录 https://blog.csdn.net/qq_42386231/article/details/120063148?utm_medium=distribute.pc_relevant.none-task-blog-2~default~baidujs_title~default-1.highlightwordscore&spm=1001.2101.3001.4242.2
     *@author: 薛微微
     *@date: 2023-06-21 17:10:40
     */
    FacebookonSuccess(response) {
      console.log("facebook response===", response);
      let _this = this;
      // 登录成功回调
      _this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            var uesr = response.authResponse.accessToken;
            let uinfoData = {
              bind_v: uesr,
              bind_type: 3,
            };
            if (response.status == "connected") {
              _this.loginSubmit(res.data, "Facebook", uinfoData);
            }
          }
        });
    },
    FacebookonFailure(error) {
      console.log("FacebookonFailure====", error);
    },
    /*
     *@description: 谷歌登录 https://developers.google.cn/identity/gsi/web/reference/js-reference?hl=zh-cn 或者 https://blog.csdn.net/weixin_43458965/article/details/125484887
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    async handleCredentialResponse(response) {
      console.log("Encoded JWT ID token: " + response);
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            let uinfoData = {
              bind_v: response.credential,
              bind_type: 2,
            };
            this.loginSubmit(res.data, "Googleplay", uinfoData);
          }
        });
    },
  },
  mounted() {
    /*
     *@description: 谷歌登录按钮样式初始化
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    window.addEventListener("click", () => {
      window.google.accounts.id.initialize({
        // 主要就是填写client_id
        client_id: this.GoogleParams.client_id,
        auto_select: false,
        callback: this.handleCredentialResponse,
      });
      // 设置按钮的样式等
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        {
          type: "standard",
          theme: "outline",
          size: "medium",
          text: "signin",
          shape: "pill",
          logo_alignment: "left",
          locale: this.$Storage.localStorageGet("lang"),
        },
      );
      // window.google.accounts.id.prompt(); // 也显示一次点击对话框
    });
  },
  created() {
    this.sendCodeShow();
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
